<script setup></script>

<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_6006_22631)">
      <!--      <rect x="6" y="5" width="24" height="24" rx="4" fill="transparent"/>-->
      <!--      <rect x="4" y="3" width="28" height="28" rx="6" stroke="white" stroke-width="4"/>-->
      <path
        d="M12.5002 21.5H10.2002C9.5405 21.5 9.0002 20.96 9.0002 20.3L9 15.7C9 15.04 9.5403 14.5 10.2 14.5H25.7998C26.4595 14.5 26.9998 15.04 26.9998 15.7L27 20.3C27 20.96 26.4597 21.5 25.8 21.5H23.5"
        stroke="#8D8D8D"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.5 14V8.5H21.1L23.5 11.4V14" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M23.5 18.5H12.5V25.5H23.5V18.5Z" stroke-width="1.07843" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15 21L20 21" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11 16H12" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15 23L20 23" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M20.5 9V11.5H23.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <filter id="filter0_d_6006_22631" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6006_22631" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6006_22631" result="shape" />
      </filter>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
